module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0022.306a29b0.jpg";